import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppTenantService {

  constructor(
    private http: HttpClient,
  ) {
  }

  setTenant(tenantId : any) {
    localStorage.setItem('Abp.TenantId',tenantId) ;
  }

  getTenant() {
      return localStorage.getItem('Abp.TenantId');
  }

  deleteTenant() {
    localStorage.removeItem('Abp.TenantId');
  }
}
